var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconIos = function SvgIconIos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.655 23.016c-1.286 1.262-2.705 1.066-4.057.47-1.438-.607-2.752-.645-4.27 0-1.891.826-2.895.586-4.034-.47-6.43-6.696-5.48-16.896 1.827-17.28 1.772.096 3.013.991 4.057 1.066 1.552-.32 3.037-1.234 4.697-1.114 1.996.163 3.488.96 4.484 2.393-4.104 2.496-3.131 7.968.639 9.504-.755 2.004-1.723 3.984-3.346 5.448zm-6.62-17.352C9.844 2.688 12.229.24 14.97 0c.378 3.432-3.084 6-4.934 5.664z"
  })));
};
export default SvgIconIos;